/**
 * @file automatically generated from MApp.Endpoints.AppEngineController
 */ 

import { MetadataClient } from '../metadataClient';
import { IGuidObject } from '../models';

export class AppEngineClient extends MetadataClient {

    public static getBrowserAppConfig(id: string) {
        return MetadataClient.ajax<string>(
            new Request(MetadataClient.endpointsUrl + `api/v1/appengine/${encodeURIComponent(id)}`)
        );
    }

    public static getLegacyBrowserRuntime(id: string) {
        return MetadataClient.ajax<string>(
            new Request(MetadataClient.endpointsUrl + `api/v1/appengine/legacyruntime/${encodeURIComponent(id)}`)
        );
    }

    public static getBrowserAppName(id: string) {
        return MetadataClient.ajax<string>(
            new Request(MetadataClient.endpointsUrl + `api/v1/appengine/${encodeURIComponent(id)}/name`)
        );
    }

    public static updateBrowserAppConfig(id: string, config: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/appengine/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(config)
			})
        );
    }

    public static getBrowserRuntimeConfig(id: string) {
        return MetadataClient.ajax<string>(
            new Request(MetadataClient.endpointsUrl + `api/v1/appengine/browserruntime/${encodeURIComponent(id)}`)
        );
    }

    public static getWarehousePrivateFile(name: string) {
        return MetadataClient.ajax<number[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/appengine/warehousefiles/private/${encodeURIComponent(name)}`)
        );
    }

    public static getWarehousePublicFile(name: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/appengine/warehousefiles/public/${encodeURIComponent(name)}`),
			true
        );
    }

    public static saveBrowserRuntime(jsonConfig: string) {
        return MetadataClient.ajax<IGuidObject>(
            new Request(MetadataClient.endpointsUrl + `api/v1/appengine/browserruntime`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(jsonConfig)
			})
        );
    }

    public static updateBrowserRuntime(id: string, jsonConfig: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/appengine/browserruntime/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(jsonConfig)
			})
        );
    }

    public static deleteBrowserRuntime(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/appengine/browserruntime/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static getAttachment(id: string, runtimeName: string, attachmentName: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/appengine/${encodeURIComponent(id)}/runtimes/${encodeURIComponent(runtimeName)}/attachments/${encodeURIComponent(attachmentName)}`),
			true
        );
    }
}
